import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { MediaQueries } from "../../components/utils";
import Changepassword from "../../components/Common/Changepassword";
import Addresslist from "../../components/Myaccount/Addresslist";
// import MobileAddress from "./MobileAddress";
import Mobileaddress from "../../components/Common/Addresslist"
import ProfileView from "../../components/Myaccount/ProfileView"
import MyAccountDashboard from "../../components/Myaccount/MyAccountDashboard";
import Trackorderbyid from "../../components/Myaccount/Trackorderbyid";
import TrackbyReferenceid from "../../components/Myaccount/TrackbyReferenceid";
import BreadComp from "../../components/Myaccount/BreadComp";
import PlacecomplaintForm from "../../components/Myaccount/PlacecomplaintForm"
import inviteimg from "../../images/invite.png"
import editeemaiimg from "../../images/email edit.png"
import trackcomplateimg from "../../images/Group.png"
// import righticon from "../../../public/assets/vector_icons/arrow_right.png"
const Complaintsuccss = () => {

    const { isMobile } = MediaQueries()

    return (
        < >
            <Container fluid className="homepagecontainer">
                <Row className={!isMobile ? "mt-4" : ""}>
                    {
                        !isMobile &&
                        <Col lg={3}>
                            <MyAccountDashboard />
                        </Col>
                    }
                  
                         

                            <Col lg={9} md={9} sm={12}>
                                {
                                     isMobile ?
                                     <div>
                                     <BreadComp title={"Place a complaints"} title0={"Manage Complaints"} link={"/complaints"} />
                                     <div className="page-titile">Place a complaints
                                     </div>
                                     </div>:
                                       <div className="Myaccount-rightsidecard">
                                       <div className="title">Place a complaints</div>
                                       <div className="discription">Register Your Complaints here..Our Customer Care Executive will get back to you soon.</div>
                                   </div>
                                }
                                <div className="Myaccount-rightsidecard mt-3 success-complaints">
                                    <div className="successcomplaint-main">Complaint Sent Successfully.</div>
                                    <div className="successcomplaint-sub">Track your complaint.</div>
                                    <NavLink to={"/manage-complaint"} className="successcomplaint-btn textdecoration-none">Track your Complaint</NavLink>

                                </div>
                              {/* <PlacecomplaintForm/> */}
                               
                            </Col>
                
                </Row>
            </Container>
        </>
    );
};

export default Complaintsuccss;
